import { PaymentSelector } from './PaymentSelector'
import { CartPurchaseInfoCard } from './CartPurchaseInfoCard'
import { FinishPurchaseButton } from './FinishPurchaseButton'
import { ShippingTypes } from './ShippingTypes'
import { CheckoutFormProps, SelectionType } from './interfaces'
import { StyledCheckoutContainer, StyledTitle, StyledFooter } from './styles/CheckoutForm.style'
import { hasTwoDaysItems } from '../../../common/productUtils'
import { useAppDispatch, useAppSelector } from '../../../common/hooks'
import { useEffect } from 'react'
import { shippingInfosActions } from '../../../store/slices/ShippingInfos'
import { DELIVERY_TYPE_ENUM } from '../../../common/constants'

export const CheckoutForm = ({
  isLoading,
  setFormValue,
  formValue,
  submitOrder,
  loginUpdated,
  showModal,
  setShowModal,
  setShowModalInstantPayment,
}: CheckoutFormProps) => {
  const { cart } = useAppSelector((state) => state)
  const cartItems = Object.values(cart).filter((item) => item.quantity > 0)

  const hasTwoDays = hasTwoDaysItems(cartItems)
  const dispatch = useAppDispatch()
  const completedProgress = false

  useEffect(() => {
    if (hasTwoDays) {
      dispatch(
        shippingInfosActions.setShippingType({
          shippingType: DELIVERY_TYPE_ENUM.twoDays,
          completedProgress,
        })
      )
    } else {
      dispatch(
        shippingInfosActions.setShippingType({
          shippingType: DELIVERY_TYPE_ENUM.fast,
          completedProgress,
        })
      )
    }
  }, [hasTwoDays])

  return (
    <StyledCheckoutContainer>
      <StyledTitle>Pagamento</StyledTitle>
      {Object.values(SelectionType).map((selectionType) => (
        <PaymentSelector
          key={`selector-${selectionType}`}
          type={selectionType}
          setFormValue={setFormValue}
          formValue={formValue}
        />
      ))}
      {hasTwoDaysItems(cartItems) && <ShippingTypes data-testid="shipping-types" />}
      <StyledFooter>
        <CartPurchaseInfoCard formValue={formValue} />
        <FinishPurchaseButton
          formValue={formValue}
          isLoading={isLoading}
          submitOrder={submitOrder}
          loginUpdated={loginUpdated}
          showModal={showModal}
          setShowModal={setShowModal}
          setShowModalInstantPayment={setShowModalInstantPayment}
        />
      </StyledFooter>
    </StyledCheckoutContainer>
  )
}
